module.exports = __webpack_public_path__ + "img/save.094081aa.svg";